import Lockr from 'lockr'
Lockr.prefix = 'lock_menu_'
export default {
  userinfo (state) {
    return () => {
      if (Lockr.get('userinfo')) {
        return Lockr.get('userinfo')
      } else {
        return state.userinfo
      }
    }
  },
  fullscreenLoading (state) {
    return state.fullscreenLoading
  },
  canteenList (state) {
    return () => {
      if (Lockr.get('canteenList')) {
        return Lockr.get('canteenList')
      } else {
        return state.canteenList
      }
    }
  }
}
